module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 152);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = require("element-ui/lib/scrollbar");

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/BLMCheckedTags/src/BLMCheckedTags.vue?vue&type=template&id=098b59b1&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "blm-checked-tags",
      style: {
        width: _vm.getValue(this.width),
        height: _vm.getValue(this.height),
      },
    },
    [
      _c(
        "div",
        { staticClass: "blm-checked-tags__action-area" },
        [
          _c("span", [
            _vm._v("已选"),
            _c("span", { staticClass: "blm-checked-tags__checked-num" }, [
              _vm._v(
                "（" +
                  _vm._s((_vm.checkedTags && _vm.checkedTags.length) || 0) +
                  "）"
              ),
            ]),
          ]),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkedTags && _vm.checkedTags.length,
                  expression: "checkedTags && checkedTags.length",
                },
              ],
              attrs: { type: "text" },
              on: { click: _vm.clearTag },
            },
            [_vm._v("清空")]
          ),
        ],
        1
      ),
      _c(
        "el-scrollbar",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.checkedTags,
              expression: "checkedTags",
            },
          ],
          ref: "scrollbar",
          staticClass: "blm-checked-tags__scrollbar",
          attrs: {
            loadFun: _vm.load,
            "wrap-class": "blm-checked-tags__scrollbar-wrap",
            "view-class": "blm-checked-tags__scrollbar-view",
            scrollFun: _vm.scroll,
          },
        },
        _vm._l(
          Math.ceil((_vm.newCheckedTags.length + 1) / _vm.groupCount),
          function (item) {
            return _c(
              "div",
              { key: item, staticClass: "virtualSelectWrap" },
              [
                _vm.showChild[item] || _vm.showChild[item] === undefined
                  ? _vm._l(
                      _vm.newCheckedTags.slice(
                        (item - 1) * _vm.groupCount,
                        item * _vm.groupCount
                      ),
                      function (tag, index) {
                        return _c(
                          "el-tag",
                          {
                            key: tag.key || tag.value || index,
                            attrs: {
                              closable: tag.disabled
                                ? false
                                : tag.closable === undefined
                                ? true
                                : tag.closable,
                              "max-width": _vm.getTagWidth,
                              disabled: tag.disabled,
                              size: "medium",
                              "disable-transitions": "",
                            },
                            on: {
                              close: function ($event) {
                                _vm.deleteTag(tag)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(tag[_vm.textKey]) +
                                "\n        "
                            ),
                          ]
                        )
                      }
                    )
                  : _vm._e(),
              ],
              2
            )
          }
        ),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/BLMCheckedTags/src/BLMCheckedTags.vue?vue&type=template&id=098b59b1&

// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
var scrollbar_ = __webpack_require__(15);
var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/BLMCheckedTags/src/BLMCheckedTags.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var BLMCheckedTagsvue_type_script_lang_js_ = ({
  name: 'BLMCheckedTags',
  components: {
    ElScrollbar: scrollbar_default.a
  },

  props: {
    checkedTags: [Array, Object],
    width: {
      type: [Number, String],
      default: 240
    },
    height: [Number, String],
    // height: {
    //   type: [Number, String],
    //   default: 206
    // },
    // 将tag分组，每组包含tag的数量
    groupCount: {
      type: [Number, String],
      default: 50
    },
    textKey: {
      type: String,
      default: 'text'
    },
    isLazyLoad: Boolean,
    firstLoadNum: {
      type: [Number, String],
      default: 40
    }
  },

  data: function data() {
    return {
      cacheCheckedTags: [],
      cutIndex: this.firstLoadNum,
      showChild: {
        1: true
      },
      isBottom: false
    };
  },

  watch: {
    checkedTags: {
      handler: function handler(val, oldVal) {
        var _this = this;

        if (!this.isLazyLoad) return;
        if (!val || !val.length) {
          this.wrap && (this.wrap.scrollTop = 0);
          this.showChild[1] = true;
          this.cutIndex = this.firstLoadNum;
          return;
        }

        // 数据量只有一组时，重置下显示状态（清空场景）
        if (val && val.length <= this.groupCount && !this.showChild[1]) {
          this.showChild[1] = true;
        }

        if (this.cutIndex > val.length) {
          this.cutIndex = Math.max(val.length, this.firstLoadNum);
        }

        var _ref = this.wrap || {},
            scrollTop = _ref.scrollTop,
            scrollHeight = _ref.scrollHeight,
            offsetHeight = _ref.offsetHeight;

        if (val.length > oldVal.length && scrollTop >= scrollHeight - offsetHeight - 10) {
          this.load();
        } else if (val.length < oldVal.length && this.isBottom) {
          // 兼容safari 已选面板滚动至底部后 去掉最后已选选项的勾选，未滚动至内容区底部
          this.$nextTick(function () {
            var _ref2 = _this.wrap || {},
                scrollTop = _ref2.scrollTop,
                scrollHeight = _ref2.scrollHeight,
                offsetHeight = _ref2.offsetHeight;

            if (scrollTop + offsetHeight > scrollHeight) {
              _this.wrap && (_this.wrap.scrollTop = scrollHeight);
            }
          });
        }
      }
    }
  },
  computed: {
    isSafari: function isSafari() {
      var userAgent = navigator.userAgent;
      return userAgent && userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1;
    },
    wrap: function wrap() {
      return this.$refs && this.$refs.scrollbar && this.$refs.scrollbar.wrap;
    },
    newCheckedTags: function newCheckedTags() {
      if (Array.isArray(this.checkedTags) && this.isLazyLoad) {
        return this.checkedTags.slice(0, this.cutIndex);
      } else {
        return this.checkedTags;
      }
    },
    getValue: function getValue() {
      return function (data) {
        if (typeof +data === 'number' && !isNaN(+data)) {
          return data + 'px';
        } else {
          return data;
        }
      };
    },
    getTagWidth: function getTagWidth() {
      if (!this.width) {
        return '';
      }
      var num = parseInt(this.width, 10);
      if (isNaN(num)) {
        return 224;
      } else {
        return num - 32;
      }
    }
  },

  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {
    scroll: function scroll(e) {
      var _this2 = this;

      if (!this.isLazyLoad) return;
      var wrap = e.target || {};
      var wrapScrollTop = wrap.scrollTop,
          wrapOffsetHeight = wrap.offsetHeight,
          wrapScrollHeight = wrap.scrollHeight;

      if (isNaN(wrapScrollTop) || isNaN(wrapOffsetHeight) || isNaN(wrapScrollHeight)) return;

      // 获取分组标签子节点
      var children = wrap.children && wrap.children[0] && wrap.children[0].childNodes || [];
      var diff = 30;
      children.forEach(function (element, idx) {
        var _ref3 = element || {},
            offsetTop = _ref3.offsetTop,
            offsetHeight = _ref3.offsetHeight;

        if (isNaN(offsetTop) || isNaN(offsetHeight)) return;
        if (offsetTop + offsetHeight < wrapScrollTop - diff || offsetTop > wrapScrollTop + wrapOffsetHeight + diff) {
          // 该组节点已滚动至不可见区域 获取固定高度赋值 并将内部tag节点销毁
          element.style.height = offsetHeight + 'px';
          if (_this2.showChild[idx + 1]) {
            _this2.$set(_this2.showChild, idx + 1, false);
          }
        } else {
          if (idx >= Math.ceil(_this2.newCheckedTags.length / _this2.groupCount) - 1) {
            element.style.height = 'auto';
          }
          if (!_this2.showChild[idx + 1]) {
            _this2.$set(_this2.showChild, idx + 1, true);
          }
        }
      });

      // 兼容safari 已选面板滚动至底部后 去掉最后已选选项的勾选，未滚动至内容区底部
      if (this.isSafari) {
        this.isBottom = wrapScrollTop + wrapOffsetHeight >= wrapScrollHeight;
      }
    },


    // 更新侧边滚动条高度
    updateScrollbar: function updateScrollbar() {
      this.$refs.scrollbar && this.$refs.scrollbar.update();
    },


    // 触底加载
    load: function load() {
      if (this.cutIndex < this.checkedTags.length) {
        this.cutIndex = this.cutIndex + 20;
      }
    },
    deleteTag: function deleteTag(tag) {
      this.$emit('deleteTag', tag);
    },
    clearTag: function clearTag() {
      this.$emit('clearTag');
    },
    scrollToBottom: function scrollToBottom() {
      var _this3 = this;

      setTimeout(function () {
        _this3.$refs.scrollbar.wrap.scrollTop = _this3.$refs.scrollbar.wrap.scrollHeight;
      }, 0);
    },

    // 更新滚动条位置
    updateScrollbarPos: function updateScrollbarPos() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.$refs.scrollbar && _this4.$refs.scrollbar.handleScroll();
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/BLMCheckedTags/src/BLMCheckedTags.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_BLMCheckedTagsvue_type_script_lang_js_ = (BLMCheckedTagsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/BLMCheckedTags/src/BLMCheckedTags.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_BLMCheckedTagsvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var BLMCheckedTags = (component.exports);
// CONCATENATED MODULE: ./packages/BLMCheckedTags/index.js


/* istanbul ignore next */
BLMCheckedTags.install = function (Vue) {
  Vue.component(BLMCheckedTags.name, BLMCheckedTags);
};

/* harmony default export */ var packages_BLMCheckedTags = __webpack_exports__["default"] = (BLMCheckedTags);

/***/ })

/******/ });